const splash = {
    dom: null,

    setAnimation() {
        const splashLogo = splash.dom.querySelector('.Splash__logo');

        setTimeout(() => {
            setTimeout(() => {
                splashLogo.classList.add('Splash__logo--active');
            }, 200);

            setTimeout(() => {
                splashLogo.classList.remove('Splash__logo--active');
                splashLogo.classList.add('Splash__logo--fade');
            }, 850);

            setTimeout(() => {
                splash.dom.classList.remove('Splash--show');
            }, 1000);
        });
    },

    init() {
        // Verifica si el usuario viene de un enlace interno
        const isInternalNavigation = document.referrer && new URL(document.referrer).hostname === window.location.hostname;
        const splashScreen = document.querySelector('.Splash');

        // Si es navegación interna, oculta el splash y no ejecuta la animación
        if (isInternalNavigation) {
            splashScreen.classList.remove('Splash--show');
            return;
        }

        splash.dom = splashScreen;
        splash.setAnimation();
    }
};

export default splash;